import HttpClient from '@/services/http-client'

class TableManufactorService extends HttpClient {
  async create(payload) {
    return this.rest.post('/v1/table-manufactors', payload)
  }

  async show(id) {
    return this.rest.get('/v1/table-manufactors/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/table-manufactors', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async update(payload) {
    return this.rest.patch('/v1/table-manufactors/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/table-manufactors/' + id)
  }
}

export default () => new TableManufactorService()
